import PropTypes from "prop-types";
import React from "react";

import {
    formatInvestorPerkAmount,
    normalizeInvestorPerks,
} from "../utils/normalizeInvestorPerks";

function EntrepreneurReviewDashboard({
    formData,
    setActiveSection,
    formDisabled,
    handleSubmit,
    onChange,
}) {
    const sections = [
        {
            title: "General Info",
            key: "generalInfo",
            fields: [
                ["First Name", formData.firstName],
                ["Last Name", formData.lastName],
                ["Email", formData.email],
                ["Phone", formData.phone],
                ["Address", formData.address1],
                ["City", formData.city],
                ["State", formData.state],
                ["Zip Code", formData.zipCode],
            ],
        },
        {
            title: "Company Details",
            key: "companyDetails",
            fields: [
                ["Company Name", formData.companyName],
                ["DBA", formData.dba],
                ["Company Website", formData.companyWebsite],
                ["Incorporated in US?", formData.incorporatedInUS],
                ["Executive Team in US?", formData.executiveTeamUS],
                ["Fundraising Goal", formData.fundRaisingGoal],
                ["Company Category", formData.companyCategory],
                ["Date Founded", formData.dateFounded],
                [
                    "EIN",
                    formDisabled && formData.ein
                        ? `*****${formData.ein.slice(-4)}`
                        : formData.ein || "",
                    "ein",
                ],
                ["Business Description", formData.businessDescription],
                ["Mission Statement", formData.missionStatement],
            ],
        },
        {
            title: "Board Members",
            key: "companyDetails",
            customRender: (
                <div className="space-y-2">
                    {(formData.boardMembers || []).map((m, i) => (
                        <div key={i} className="flex gap-2 items-center">
                            {formDisabled ? (
                                <p>
                                    {m.name} - {m.title}
                                </p>
                            ) : (
                                <>
                                    <input
                                        type="text"
                                        name={`boardMember_name_${i}`}
                                        value={m.name}
                                        onChange={(e) => {
                                            const updated = [
                                                ...formData.boardMembers,
                                            ];
                                            updated[i].name = e.target.value;
                                            onChange({
                                                target: {
                                                    name: "boardMembers",
                                                    value: updated,
                                                },
                                            });
                                        }}
                                        placeholder="Name"
                                        className="p-2 border border-cyan-800 rounded-xl w-1/2"
                                    />
                                    <input
                                        type="text"
                                        name={`boardMember_title_${i}`}
                                        value={m.title}
                                        onChange={(e) => {
                                            const updated = [
                                                ...formData.boardMembers,
                                            ];
                                            updated[i].title = e.target.value;
                                            onChange({
                                                target: {
                                                    name: "boardMembers",
                                                    value: updated,
                                                },
                                            });
                                        }}
                                        placeholder="Title"
                                        className="p-2 border border-cyan-800 rounded-xl w-1/2"
                                    />
                                </>
                            )}
                        </div>
                    ))}
                </div>
            ),
        },
        // {
        //     title: "Uploads",
        //     key: "uploads",
        //     customRender: (
        //         <>
        //             {formDisabled ? (
        //                 <ul className="ml-4 list-disc">
        //                     {(formData.uploadedFiles || []).map((f, i) => <li key={i}>{f}</li>)}
        //                 </ul>
        //             ) : (
        //                 <>
        //                     <input type="file" multiple onChange={(e) => onFileUpload(e.target.files, 'uploadedFiles')} />
        //                     <ul className="ml-4 list-disc mt-2">
        //                         {(formData.uploadedFiles || []).map((f, i) => (
        //                             <li key={i} className="flex items-center gap-2">
        //                                 <a href={`${process.env.REACT_APP_BACKEND_URL}${f}`} target="_blank" rel="noopener noreferrer" className="underline text-blue-700">
        //                                     {f.split("/").pop()}
        //                                 </a>
        //                                 {!formDisabled && (
        //                                     <button
        //                                         onClick={() => onFileDelete(f, 'uploadedFiles')}
        //                                         className="text-red-600 hover:text-red-800 text-sm"
        //                                     >
        //                                         Delete
        //                                     </button>
        //                                 )}
        //                             </li>
        //                         ))}
        //                     </ul>

        //                 </>
        //             )}
        //         </>
        //     )
        // },
        {
            title: "Uploads",
            key: "uploads",
            customRender: (
                <>
                    {formDisabled ? (
                        <div className="space-y-2">
                            {formData.uploadedFiles &&
                                Object.entries(formData.uploadedFiles).map(
                                    ([docType, files], index) => (
                                        <div key={index}>
                                            <span className="font-semibold text-navy capitalize">
                                                {docType.replace(
                                                    /([A-Z])/g,
                                                    " $1",
                                                )}
                                                :
                                            </span>
                                            <ul className="ml-4 list-disc">
                                                {(Array.isArray(files)
                                                    ? files
                                                    : [files]
                                                ).map((f, i) => {
                                                    const isValid =
                                                        typeof f === "string";
                                                    const fileName = isValid
                                                        ? f.split("/").pop()
                                                        : "Invalid file";
                                                    // Construct URL properly - ensure no double slashes
                                                    const fileUrl = isValid
                                                        ? `${
                                                              process.env
                                                                  .REACT_APP_BACKEND_URL
                                                          }/${
                                                              f.startsWith("/")
                                                                  ? f.substring(
                                                                        1,
                                                                    )
                                                                  : f
                                                          }`
                                                        : "#";

                                                    return (
                                                        <li key={i}>
                                                            <a
                                                                href={fileUrl}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="underline text-blue-700"
                                                            >
                                                                {fileName}
                                                            </a>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    ),
                                )}
                        </div>
                    ) : (
                        <div className="space-y-2 mt-2">
                            {formData.uploadedFiles &&
                                Object.entries(formData.uploadedFiles).map(
                                    ([docType, files], index) => (
                                        <div key={index}>
                                            <span className="font-semibold text-navy capitalize">
                                                {docType.replace(
                                                    /([A-Z])/g,
                                                    " $1",
                                                )}
                                                :
                                            </span>
                                            <ul className="ml-4 list-disc">
                                                {(Array.isArray(files)
                                                    ? files
                                                    : [files]
                                                ).map((f, i) => {
                                                    const isValid =
                                                        typeof f === "string";
                                                    const fileName = isValid
                                                        ? f.split("/").pop()
                                                        : "Invalid file";
                                                    // Construct URL properly - ensure no double slashes
                                                    const fileUrl = isValid
                                                        ? `${
                                                              process.env
                                                                  .REACT_APP_BACKEND_URL
                                                          }/${
                                                              f.startsWith("/")
                                                                  ? f.substring(
                                                                        1,
                                                                    )
                                                                  : f
                                                          }`
                                                        : "#";

                                                    return (
                                                        <li
                                                            key={i}
                                                            className="flex items-center gap-2"
                                                        >
                                                            <a
                                                                href={fileUrl}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="underline text-blue-700"
                                                            >
                                                                {fileName}
                                                            </a>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    ),
                                )}
                        </div>
                    )}
                </>
            ),
        },
        {
            title: "Account Details",
            key: "accountDetails",
            fields: [
                ["Contact Name", formData.contactName],
                ["About Me", formData.aboutMe],
                ["Title/Role", formData.titleRole],
                ["LinkedIn", formData.linkedin],
                ["Why Investment", formData.whyInvestment],
                ["Equity Stake", formData.equityStake],
                ["Achievements", formData.achievements],
                ["Experience", formData.experience],
                ["Projects", formData.projects],
            ],
        },
        {
            title: "Investment Details",
            key: "investmentDetails",
            fields: [
                ["Investment Name", formData.investmentName],
                ["Pitch", formData.investmentPitch],
                ["Investment Minimum", formData.investmentMinimum],
                ["State", formData.investmentState],
                ["Funding History", formData.fundingHistory],
                ["Revenue Growth", formData.revenueGrowth],
                ["Equity Offered", formData.equityOffered],
                ["Revenue Status", formData.revenueStatus],
                ["TAM", formData.tam],
                ["Risks/Challenges", formData.risksChallenges],
                ["Competitive Advantage", formData.competitiveAdvantage],
                ["Exit Strategy", formData.exitStrategy],
                ["Valuation", formData.valuation],
                ["Other Investors", formData.otherInvestors],
            ],
        },
        {
            title: "Investor Perks",
            key: "investmentDetailsCont",
            customRender: (
                <div className="space-y-3">
                    {!formDisabled && (
                        <p className="text-xs text-gray-500">
                            Add up to 5 perks
                        </p>
                    )}
                    {normalizeInvestorPerks(formData.investorPerks).map(
                        (perk, index) => (
                            <div
                                key={index}
                                className="flex flex-col items-start gap-2 sm:flex-row sm:items-center"
                            >
                                {formDisabled ? (
                                    <p>
                                        {perk.amount && (
                                            <strong className="mr-2">
                                                {formatInvestorPerkAmount(
                                                    perk.amount,
                                                )}
                                            </strong>
                                        )}
                                        {perk.description || "—"}
                                    </p>
                                ) : (
                                    <>
                                        <input
                                            type="text"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            name="amount"
                                            value={perk.amount}
                                            onChange={(e) =>
                                                onChange(
                                                    e,
                                                    index,
                                                    "investorPerks",
                                                )
                                            }
                                            placeholder="Investment amount"
                                            maxLength={30}
                                            className="h-11 w-full rounded-xl border border-cyan-800 p-2 sm:w-1/3"
                                        />
                                        <textarea
                                            name="description"
                                            value={perk.description}
                                            onChange={(e) =>
                                                onChange(
                                                    e,
                                                    index,
                                                    "investorPerks",
                                                )
                                            }
                                            placeholder="Describe the investor perk"
                                            maxLength={500}
                                            rows={1}
                                            className="h-11 w-full resize-none rounded-xl border border-cyan-800 p-2 sm:w-2/3"
                                        />
                                        <div className="flex gap-2">
                                            {normalizeInvestorPerks(
                                                formData.investorPerks,
                                            ).length < 5 && (
                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        onChange({
                                                            target: {
                                                                name: "investorPerks",
                                                                value: [
                                                                    ...normalizeInvestorPerks(
                                                                        formData.investorPerks,
                                                                    ),
                                                                    {
                                                                        amount: "",
                                                                        description:
                                                                            "",
                                                                    },
                                                                ],
                                                            },
                                                        })
                                                    }
                                                    className="p-1 text-xl font-bold text-navy"
                                                    title="Add perk"
                                                >
                                                    +
                                                </button>
                                            )}
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    const perks =
                                                        normalizeInvestorPerks(
                                                            formData.investorPerks,
                                                        );
                                                    onChange({
                                                        target: {
                                                            name: "investorPerks",
                                                            value:
                                                                perks.length ===
                                                                1
                                                                    ? [
                                                                        {
                                                                            amount: "",
                                                                            description:
                                                                                "",
                                                                        },
                                                                    ]
                                                                    : perks.filter(
                                                                        (
                                                                            _,
                                                                            perkIndex,
                                                                        ) =>
                                                                            perkIndex !==
                                                                            index,
                                                                    ),
                                                        },
                                                    });
                                                }}
                                                className="p-1 text-xl font-bold text-red-600"
                                                title="Remove perk"
                                            >
                                                &minus;
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        ),
                    )}
                </div>
            ),
        },
        {
            title: "Social Links",
            key: "socialLinks",
            customRender: (
                <div className="space-y-2">
                    {(formData.socialLinks || []).map((link, index) => (
                        <div key={index}>
                            <label className="text-cyan-800">
                                Social Link #{index + 1}:
                            </label>
                            {formDisabled ? (
                                <p>{link || "—"}</p>
                            ) : (
                                <input
                                    type="text"
                                    value={link}
                                    onChange={(e) =>
                                        onChange(e, index, "socialLinks")
                                    }
                                    className="p-2 border border-cyan-800 rounded-xl w-full"
                                />
                            )}
                        </div>
                    ))}
                </div>
            ),
        },
        {
            title: "Media & Press",
            key: "mediaAndPress",
            customRender: (
                <>
                    {formDisabled ? (
                        <>
                            {/* Check both mediaUploads and campaignMediaUploads */}
                            {(formData.mediaUploads || []).length > 0 ||
                            (formData.campaignMediaUploads || []).length > 0 ? (
                                <div className="mb-4">
                                    <h4 className="font-semibold text-navy mb-2">
                                        Media Files:
                                    </h4>
                                    <ul className="ml-4 space-y-2">
                                        {/* Display both mediaUploads and campaignMediaUploads */}
                                        {[
                                            ...(formData.mediaUploads || []),
                                            ...(formData.campaignMediaUploads ||
                                                []),
                                        ].map((f, i) => {
                                            if(!f) return null;

                                            // Extract clean filename and construct URL
                                            const fileName = f.split("/").pop();
                                            const cleanFileName =
                                                fileName.replace(/^\d+-/, "");
                                            const fileUrl = f.startsWith("http")
                                                ? f
                                                : `${process.env.REACT_APP_BACKEND_URL}/${f}`;

                                            // Determine file type
                                            const isImage =
                                                /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(
                                                    fileName,
                                                );
                                            const isAudio =
                                                /\.(mp3|wav|ogg|m4a|aac)$/i.test(
                                                    fileName,
                                                );
                                            const isVideo =
                                                /\.(mp4|avi|mov|wmv|flv|webm)$/i.test(
                                                    fileName,
                                                );

                                            return (
                                                <li
                                                    key={i}
                                                    className="border rounded-lg p-3"
                                                >
                                                    <div className="flex items-center justify-between mb-2">
                                                        <span className="font-medium text-gray-800">
                                                            {cleanFileName}
                                                        </span>
                                                        <a
                                                            href={fileUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-blue-600 hover:text-blue-800 text-sm underline"
                                                        >
                                                            Download
                                                        </a>
                                                    </div>

                                                    {/* Media Preview */}
                                                    <div className="mt-2">
                                                        {isImage && (
                                                            <img
                                                                src={fileUrl}
                                                                alt={
                                                                    cleanFileName
                                                                }
                                                                className="max-w-xs max-h-48 object-contain rounded border"
                                                                onError={(
                                                                    e,
                                                                ) => {
                                                                    e.target.style.display =
                                                                        "none";
                                                                }}
                                                            />
                                                        )}
                                                        {isAudio && (
                                                            <audio
                                                                controls
                                                                className="max-w-xs"
                                                                onError={(
                                                                    e,
                                                                ) => {
                                                                    e.target.style.display =
                                                                        "none";
                                                                }}
                                                            >
                                                                <source
                                                                    src={
                                                                        fileUrl
                                                                    }
                                                                />
                                                                Your browser
                                                                does not support
                                                                audio playback.
                                                            </audio>
                                                        )}
                                                        {isVideo && (
                                                            <video
                                                                controls
                                                                className="max-w-xs max-h-48"
                                                                onError={(
                                                                    e,
                                                                ) => {
                                                                    e.target.style.display =
                                                                        "none";
                                                                }}
                                                            >
                                                                <source
                                                                    src={
                                                                        fileUrl
                                                                    }
                                                                />
                                                                Your browser
                                                                does not support
                                                                video playback.
                                                            </video>
                                                        )}
                                                    </div>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            ) : (
                                <p className="text-gray-500 mb-4">
                                    No media files uploaded.
                                </p>
                            )}

                            {formData.videoUrl && (
                                <div>
                                    <h4 className="font-semibold text-navy mb-2">
                                        Video URL:
                                    </h4>
                                    <a
                                        href={formData.videoUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 hover:text-blue-800 underline"
                                    >
                                        {formData.videoUrl}
                                    </a>
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            <div>
                                <label className="text-cyan-800 font-semibold">
                                    Media Files:
                                </label>
                                <ul className="ml-4 list-disc mt-2">
                                    {/* Display both mediaUploads and campaignMediaUploads */}
                                    {[
                                        ...(formData.mediaUploads || []),
                                        ...(formData.campaignMediaUploads ||
                                            []),
                                    ].map((f, i) => {
                                        if(!f) return null;
                                        const fileName = f.split("/").pop();
                                        const fileUrl = f.startsWith("http")
                                            ? f
                                            : `${process.env.REACT_APP_BACKEND_URL}/${f}`;
                                        return (
                                            <li key={i}>
                                                <a
                                                    href={fileUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="underline text-blue-700"
                                                >
                                                    {fileName}
                                                </a>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                            <div className="mb-4 mt-4">
                                <label className="text-cyan-800 font-semibold">
                                    Video URL:
                                </label>
                                <input
                                    type="text"
                                    name="videoUrl"
                                    value={formData.videoUrl || ""}
                                    onChange={onChange}
                                    className="mt-1 p-2 border border-cyan-800 rounded-xl w-full"
                                    placeholder="Video URL (YouTube or Vimeo)"
                                />
                            </div>
                        </>
                    )}
                </>
            ),
        },
    ];
    const labelToFieldName = (label) => {
        const map = {
            "First Name": "firstName",
            "Last Name": "lastName",
            Email: "email",
            Phone: "phone",
            Address: "address1",
            City: "city",
            State: "state",
            "Zip Code": "zipCode",
            "Company Name": "companyName",
            DBA: "dba",
            "Company Website": "companyWebsite",
            "Incorporated in US?": "incorporatedInUS",
            "Executive Team in US?": "executiveTeamUS",
            "Fundraising Goal": "fundRaisingGoal",
            "Company Category": "companyCategory",
            "Date Founded": "dateFounded",
            EIN: "ein",
            "Business Description": "businessDescription",
            "Mission Statement": "missionStatement",
            "Contact Name": "contactName",
            "About Me": "aboutMe",
            "Title/Role": "titleRole",
            LinkedIn: "linkedin",
            "Why Investment": "whyInvestment",
            "Equity Stake": "equityStake",
            Achievements: "achievements",
            Experience: "experience",
            Projects: "projects",
            "Investment Name": "investmentName",
            Pitch: "investmentPitch",
            "Investment Minimum": "investmentMinimum",
            State: "investmentState",
            "Funding History": "fundingHistory",
            "Revenue Growth": "revenueGrowth",
            "Equity Offered": "equityOffered",
            "Revenue Status": "revenueStatus",
            TAM: "tam",
            "Risks/Challenges": "risksChallenges",
            "Competitive Advantage": "competitiveAdvantage",
            "Exit Strategy": "exitStrategy",
            Valuation: "valuation",
            "Other Investors": "otherInvestors",
            "Investor Perks": "investorPerks",
        };
        return map[label] || "";
    };

    return (
        <div className="font-poppins">
            <div className="mt-6 space-y-12">
                <h2 className="text-xl font-semibold text-navy mb-4 text-center font-poppins">
                    REVIEW YOUR INFORMATION
                </h2>

                {sections.map((section, i) => (
                    <div key={i} className="relative border-b pb-6">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-bold text-navy">
                                {section.title}
                            </h3>
                            {!formDisabled && (
                                <button
                                    onClick={() =>
                                        setActiveSection(section.key)
                                    }
                                    className="flex items-center space-x-1 text-sm text-navy hover:underline"
                                ></button>
                            )}
                        </div>

                        {section.customRender ? (
                            <div className="text-sm text-gray-800">
                                {section.customRender}
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-800">
                                {section.fields.map(([label, value]) => {
                                    const name = labelToFieldName(label);
                                    return (
                                        <div key={label}>
                                            <span className="font-semibold text-navy">
                                                {label}:
                                            </span>
                                            {formDisabled ? (
                                                <p>{value || "—"}</p>
                                            ) : (
                                                <input
                                                    type="text"
                                                    name={name}
                                                    value={formData[name] || ""}
                                                    onChange={onChange}
                                                    className="p-2 border border-navy rounded-xl w-full"
                                                />
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                ))}

                {!formDisabled && (
                    <div className="flex justify-end mt-6">
                        <button
                            onClick={handleSubmit}
                            className="aqi-primary-action rounded-xl bg-navy px-12 py-2 font-bold text-white shadow-md hover:bg-navy-2 font-poppins"
                        >
                            UPDATE & SUBMIT
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

EntrepreneurReviewDashboard.propTypes = {
    formData: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
        address1: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        zipCode: PropTypes.string,
        companyName: PropTypes.string,
        dba: PropTypes.string,
        companyWebsite: PropTypes.string,
        incorporatedInUS: PropTypes.string,
        executiveTeamUS: PropTypes.string,
        fundRaisingGoal: PropTypes.string,
        companyCategory: PropTypes.string,
        dateFounded: PropTypes.string,
        ein: PropTypes.string,
        businessDescription: PropTypes.string,
        missionStatement: PropTypes.string,
        boardMembers: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
        uploadedFiles: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
        contactName: PropTypes.string,
        aboutMe: PropTypes.string,
        titleRole: PropTypes.string,
        linkedin: PropTypes.string,
        whyInvestment: PropTypes.string,
        equityStake: PropTypes.string,
        achievements: PropTypes.string,
        experience: PropTypes.string,
        projects: PropTypes.string,
        investmentName: PropTypes.string,
        investmentPitch: PropTypes.string,
        investmentMinimum: PropTypes.string,
        investmentState: PropTypes.string,
        fundingHistory: PropTypes.string,
        revenueGrowth: PropTypes.string,
        equityOffered: PropTypes.string,
        revenueStatus: PropTypes.string,
        tam: PropTypes.string,
        risksChallenges: PropTypes.string,
        competitiveAdvantage: PropTypes.string,
        exitStrategy: PropTypes.string,
        valuation: PropTypes.string,
        otherInvestors: PropTypes.string,
        investorPerks: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.string,
        ]),
        socialLinks: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
        mediaUploads: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
        campaignMediaUploads: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.string,
        ]),
        videoUrl: PropTypes.string,
    }).isRequired,
    setActiveSection: PropTypes.func.isRequired,
    formDisabled: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default EntrepreneurReviewDashboard;
